import { User } from "../user/user.model";
import { BaseRate } from "./rate-base.model";
import { Client } from "../client/client.model";
import { Rate } from "./rate-type";
import { Carrier } from "../carrier/carrier.model";
import { ContainerName } from "../shared/container/container-name.type.const";

export class FclPickupDeliveryRate extends BaseRate {
  constructor(
    protected id: number,
    protected name: string,
    protected discriminator: string,
    protected rangeType: string,
    protected equipment: ContainerName[] = [],
    protected createdBy?: User,
    protected updatedBy?: User,
    protected createdAt?: Date,
    protected updatedAt?: Date,
    protected type?: string,
    protected source?: string,
    protected status?: string,
    protected internalNote?: string,
    protected externalNote?: string,
    protected pmNote?: string,
    protected comment?: string,
    protected deepLink?: string,
    protected carrier?: Carrier,
    protected validity?: Date[],
    protected contractNumber?: string,
    protected availableOnline?: boolean,
    protected restrictedClients?: Client[],
    protected restrictedUsers?: User[],
    protected rootParent?: Rate,
    public currency?: string,
    public terminalType?: string,
    public direction?: string,
    public hiddenMarkup?: number,
  ) {
    super(
      id,
      name,
      discriminator,
      createdBy,
      updatedBy,
      createdAt,
      updatedAt,
      type,
      source,
      status,
      internalNote,
      externalNote,
      pmNote,
      comment,
      deepLink,
      carrier,
      validity,
      contractNumber,
      restrictedClients,
      restrictedUsers,
      rootParent,
    );
  }

  public getAvailableOnline(): boolean {
    return this.availableOnline;
  }

  public setAvailableOnline(availableOnline: boolean) {
    this.availableOnline = availableOnline;
  }

  public getRangeType(): string {
    return this.rangeType;
  }

  public getEquipment(): ContainerName[] {
    return this.equipment;
  }

  public setEquipment(param: ContainerName[]) {
    this.equipment = param;
  }

  public getCurrency() {
    return this.currency;
  }

  public setCurrency(currency: string) {
    this.currency = currency;
  }

  public isValid(): boolean {
    return (
      !!this.name &&
      !!this.carrier &&
      !!this.validity &&
      !!this.equipment &&
      this.equipment.length > 0
    );
  }
}
